import {useMixpanel, UseMixpanelParams} from './analytics/useMixpanel';
import {useZoomInfo} from './analytics/useZoomInfo';

export function useAnalyticsService(mixpanelParams?: UseMixpanelParams) {
  const mixpanel = useMixpanel(mixpanelParams);
  useZoomInfo();

  return {mixpanel};
}
